<template v-if="isShowProductPrice">
  <div :class="['p-price', priceClass]" :style="[priceStyles]">
    <div v-html="product.price_html"></div>
  </div>
</template>

<script>
export default {
  name: "ProductPrice",
  props: ["product"],
  computed: {
    // price
    isShowProductPrice: function() {
      return this.$store.state.front.settings.priceDisplay;
    },
    priceStyles: function() {
      return {
        color: this.$store.state.front.settings.priceColor,
        fontSize: this.$store.state.front.settings.priceFontsize + "px"
      };
    },
    priceClass: function() {
      return this.$store.state.front.settings.priceClass;
    }
  }
};
</script>

<style lang="scss" scoped>
.p-price {
  margin: auto;
}
</style>